export class ApiError extends Error { constructor(message: string, public status: number) { super(message); } }
export async function api<T>(path: string, method = 'GET', body?: unknown, headers: Record<string, string> = {}, signal?: AbortSignal): Promise<T> {
  const response = await fetch(`/api${path}`, { method, credentials: 'include', headers: { ...(body === undefined ? {} : { 'Content-Type': 'application/json' }), ...headers }, body: body === undefined ? undefined : JSON.stringify(body), signal });
  const data = await response.json();
  if (!response.ok) throw new ApiError(data.error || 'Please try again.', response.status);
  return data;
}
export async function uploadPhoto(file: File) {
  if (!file.type.startsWith('image/')) throw new Error('Please choose an image.');
  const bitmap = await createImageBitmap(file);
  let edge = 1024, blob: Blob | null = null;
  const canvas = document.createElement('canvas');
  try {
    while (true) {
      const scale = Math.min(1, edge / Math.max(bitmap.width, bitmap.height));
      canvas.width = Math.max(1, Math.round(bitmap.width * scale)); canvas.height = Math.max(1, Math.round(bitmap.height * scale));
      canvas.getContext('2d')!.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      blob = await new Promise<Blob>((resolve, reject) => canvas.toBlob(value => value ? resolve(value) : reject(new Error('Could not read image.')), 'image/png'));
      if (blob.size <= 512 * 1024) break;
      edge = Math.max(1, Math.floor(edge * .7));
    }
  } finally { bitmap.close(); }
  const response = await fetch('/api/assets', { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'image/png' }, body: blob });
  const data = await response.json(); if (!response.ok) throw new Error(data.error); return data.id as string;
}
